import * as Yup from 'yup';

export const schema = Yup.object().shape({
  name: Yup.string().max(100, 'name.max').required('name.required'),
});
